import LclOrderModule from './LclOrderModule'

// 整柜下单：复用拼柜/整柜共用的下单表单（发件人/收件人/货物一致，运输方案为整柜）
export default function FclOrderModule() {
  return <LclOrderModule mode="fcl" />
}
